// extracted by mini-css-extract-plugin
module.exports = {"container":"acx_container__1crWV","sidebar":"acx_sidebar__1PXqx","rightsection":"acx_rightsection__3t1gZ"};